<template>
    <div :class="{
        score: true,
        score_error: hasError,
    }">
        <div>{{ score.name }} (от {{ score.minScore }} до {{ score.maxScore }})</div>
        <div><input v-model="inputValue" class="score__input" type="number" :min="score.minScore" :readonly="readonly" /></div>
        <div v-if="hasError" class="score__error">Вне диапазона</div>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAssessmentScore",
    props: {
        score: Object,
        value: String,
        readonly: Boolean,
    },
    data() {
        return {
            inputValue: this.value,
        };
    },
    computed: {
        hasError() {
            return this.inputValue > this.score.maxScore || this.inputValue < this.score.minScore;
        },
    },
    watch: {
        inputValue() {
            this.$emit('completed', !!this.inputValue && !this.hasError);
            this.$emit('input', this.inputValue);
        },
    },
    mounted() {
        this.$emit('completed', !!this.inputValue && !this.hasError);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.score {
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: rem(16);
  line-height: rem(24);
  color: #2A2626;
  display: flex;
  align-items: center;
  gap: rem(24);
  &__input {
    padding: rem(12) rem(16);
    background: #FFFFFF;
    border: rem(2) solid #4663AB;
    border-radius: rem(10);
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(30);
    color: #4663AB;
    width: rem(100);
    &[readonly] {
      opacity: 0.4;
    }
  }
  &__error {
    font-weight: normal;
    font-size: rem(14);
  }
  &_error, &_error * {
    color: #d1004a;
    .score__input {
      border: rem(2) solid #d1004a;
    }
  }
}
</style>